export const LIST_END_REACHED_THRESHOLD = 1
export const LIST_LOAD_LIMIT = 20
export const LIST_INITIAL_NUM_RENDERING = 10
export const LIST_CHUNK_LENGTH = 5000
export const LIST_CHUNK_RADIUS = 1
